"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.takeElementScreenshot = void 0;
const html2canvas_1 = __importDefault(require("html2canvas"));
const constants_1 = require("../constants/constants");
const takeElementScreenshot = (elementId) => __awaiter(void 0, void 0, void 0, function* () {
    const _document = document.getElementById(elementId);
    if (!_document)
        return;
    const canvas = yield (0, html2canvas_1.default)(_document);
    const dataURL = canvas.toDataURL(constants_1.CANVAS_IMAGE_TYPE);
    // OR Convert to File
    const file = dataURLtoFile(dataURL, "image.png");
    return file;
});
exports.takeElementScreenshot = takeElementScreenshot;
function dataURLtoBlob(dataURL) {
    const [header, base64] = dataURL.split(",");
    const mime = header.match(/:(.*?);/)[1];
    const binary = atob(base64);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        array[i] = binary.charCodeAt(i);
    }
    return new Blob([array], { type: mime });
}
function dataURLtoFile(dataURL, filename) {
    const blob = dataURLtoBlob(dataURL);
    return new File([blob], filename, { type: blob.type });
}
